<div class="status-tracker">
	<div *ngFor="let status of statuses; let i= index" class="status-item" [ngClass]="{
		'final-status-item':i===statuses.length-1
	}">
		<div class="status-circle" [ngClass]="{
				'completed':i<currentIndex,
				'current':i===currentIndex,
				'upcoming':i>currentIndex,
				'blank':i===0,
			}"></div>
		<div *ngIf="i<statuses.length-1" class="status-line-container">
			<div class="status-line" [ngClass]="{
				'completed':i<currentIndex}">
			</div>
		</div>
		<div *ngIf="i>0" class="status-label" [ngClass]="{'even':i%2===1,
		'odd':i%2===0,
		'completed-label':i<currentIndex,
		'current-label':i===currentIndex,
		'upcoming-label': i>currentIndex}">
			{{ status | translate}}
		</div>
	</div>
</div>
